export const de = {
  seo: {
    ogLocale: "de_DE",
    home: {
      title: "4-Tage-Woche im Bankenwesen | Whitepaper 2026",
      description: "Wie Banken mit der 4-Tage-Woche den Fachkräftemangel lösen: Fallstudien, KI-Dividende und Arbeitgeberattraktivität. Kostenloses Whitepaper.",
    },
    businessCase: {
      title: "Business Case anfragen | 4-Tage-Woche im Bankenwesen",
      description: "Individueller Business Case zur 4-Tage-Woche für Ihre Bank: Anfrage stellen und massgeschneiderte Analyse von Intraprenör erhalten.",
    },
  },
  hero: {
    badge: "Whitepaper 2026",
    title1: "Die 4-Tage-Woche",
    title2: "im Bankenwesen",
    subtitle: "Zwischen Arbeitgeberattraktivität und KI-Dividende: Wie Banken mit der 4-Tage-Woche den Fachkräftemangel lösen",
    downloadButton: "Whitepaper herunterladen",
    learnMore: "Mehr erfahren",
  },
  stats: {
    title: "Die Zahlen",
    titleItalic: "sprechen für sich",
    subtitle: "Internationale Studien und Praxisbeispiele zeigen: Die 4-Tage-Woche ist kein Experiment mehr.",
    items: [
      { suffix: "%", label: "Fortführung", description: "der Unternehmen im deutschen Pilotprojekt führen die 4-Tage-Woche fort" },
      { suffix: "x", label: "Mehr Bewerbungen", description: "Verfünffachung der Bewerbungszahlen bei PSD Bank Braunschweig" },
      { suffix: "%", label: "Weniger Krankheitstage", description: "Reduktion der krankheitsbedingten Abwesenheit bei der Atom Bank (UK)" },
    ],
  },
  cases: {
    title1: "Die 4-Tage-Woche Pioniere:",
    title2: "4 Banking Cases, die zeigen,",
    titleItalic: "wie es funktionieren kann",
    subtitle: "Diese Banken beweisen: Die 4-Tage-Woche funktioniert – von der digitalen Neobank bis zur traditionellen Sparkasse.",
    resultsLabel: "Ergebnisse",
    items: [
      {
        type: "Der Digitale Vorreiter",
        highlight: "68 % weniger Krankheitstage",
        model: "4-Tage-Woche bei vollem Gehalt seit 2021",
        results: [
          
          "49% erhöhte Bewerbungen",
          "68% weniger Krankheitstage",
          "Fluktuation um 57% gesunken",
        ],
      },
      {
        type: "Die Regionale Genossenschaftsbank",
        highlight: "Alle Stellen besetzt",
        model: "4-Tage-Woche als Pilotprojekt",
        results: [
          "Verfünffachung der Bewerbungszahlen",
          "Alle vakanten Stellen erfolgreich besetzt",
          "Deutliche Reduktion der Krankheitstage",
          "Hohe Mitarbeiterzufriedenheit",
        ],
        quote: {
          text: "Früher hatten wir auf eine Stellenanzeige kaum Reaktionen. Heute bekommen wir auf jede Ausschreibung 50 bis 60 Bewerbungen.",
          author: "Carsten Graf",
          role: "Vorstandsvorsitzender PSD Bank Braunschweig",
        },
      },
      {
        type: "Die Solide Innovatorin",
        highlight: "Attraktivste Arbeitgeberin der Region",
        model: "4-Tage-Woche seit 2024",
        results: [
          "Wechsel von Mitarbeitern aus Großbanken (Credit Suisse, UBS)",
          "Attraktivste Arbeitgeberin in der ländlichen Region",
          "Produktivität auf gleichem Niveau gehalten",
          "Starke Positionierung im Wettbewerb um Talente",
        ],
      },
      {
        type: "Die Flexible Großsparkasse",
        highlight: "Wahlfreiheit für Mitarbeitende",
        model: "4-Tage-Woche als Teil des 'WertSchätze'-Konzepts",
        results: [
          "4-Tage-Woche als Wahlmöglichkeit angeboten",
          "Teil eines umfassenden Wertschätzungskonzepts",
          "Flexible Arbeitszeitmodelle für verschiedene Lebensphasen",
          "Erhöhte Mitarbeiterbindung",
        ],
      },
    ],
  },
  trends: {
    badge: "4 Treiber",
    title: "Warum die 4-Tage-Woche",
    titleItalic: "funktioniert",
    subtitle: "Vier zentrale Faktoren machen die 4-Tage-Woche zum Erfolgsmodell für Banken.",
    items: [
      {
        title: "Attraktivität & Mitarbeitendenbindung",
        subtitle: "Die Recruiting-Revolution",
        stats: [
          { value: "5x", label: "Mehr Bewerbungen" },
          { value: "57%", label: "Weniger Fluktuation" },
        ],
        description: "Die 4-Tage-Woche ist das wirksamste Mittel gegen den Fachkräftemangel im Bankensektor. Banken berichten von einer Verfünffachung der Bewerbungszahlen und einer dramatischen Reduktion der Fluktuation.",
        insight: "Uns hat noch kein einziger Mitarbeiter verlassen – Hans-Jürgen Lembicz, Volksbank Euskirchen",
      },
      {
        title: "Gesundheit von Mitarbeitenden",
        subtitle: "Weniger Stress, mehr Wohlbefinden",
        stats: [
          { value: "68%", label: "Weniger Krankheitstage" },
          { value: "89 Min", label: "Weniger Stress/Woche" },
        ],
        description: "Die zusätzliche Erholungszeit führt zu messbaren Verbesserungen der physischen und psychischen Gesundheit. Krankheitstage sinken drastisch, Burnout-Raten gehen zurück.",
        insight: "Arbeitnehmer gewinnen durchschnittlich 89 Minuten weniger stressreiche Arbeitszeit pro Woche zurück.",
      },
      {
        title: "Kosten & Effizienz",
        subtitle: "Der Business Case",
        stats: [
          { value: "65%", label: "Optimierte Prozesse" },
          { value: "100%", label: "Produktivität erhalten" },
        ],
        description: "Weniger Arbeitszeit bedeutet nicht weniger Output. Durch Prozessoptimierung und erhöhte Fokussierung bleibt die Produktivität auf gleichem Niveau.",
        insight: "65% der deutschen Pilotbetriebe haben durch die 4-Tage-Woche unnötige Meetings, Aufgaben und Prozesse eliminiert.",
      },
      {
        title: "Künstliche Intelligenz",
        subtitle: "Die KI-Dividende",
        stats: [
          { value: "3,5", label: "Tage laut JPMorgan" },
          { value: "30%", label: "Potenzielle Zeitersparnis" },
        ],
        description: "KI-gestützte Automatisierung im Bankensektor schafft Spielraum für kürzere Arbeitszeiten. JPMorgan-CEO Jamie Dimon prognostiziert: Die 3,5-Tage-Woche kommt in einer Generation.",
        insight: "KI und Automatisierung ermöglichen es, die Produktivitätsgewinne als Freizeit an Mitarbeitende zurückzugeben.",
      },
    ],
  },
  quotes: {
    title: "Stimmen",
    titleItalic: "aus der Praxis",
    subtitle: "Was Führungskräfte über ihre Erfahrungen mit der 4-Tage-Woche berichten.",
    items: [
      {
        text: "Uns hat noch kein einziger Mitarbeiter verlassen. Normalerweise haben wir immer so eine Fluktuation von etwa fünf Prozent, aber im Moment liegt die bei Null.",
        author: "Hans-Jürgen Lembicz",
        role: "Vorstand",
        company: "Volksbank Euskirchen",
      },
      {
        text: "Schon im ersten halben Jahr stieg unsere Produktivität. Keine Einbussen, im Gegenteil: höhere Fokussierung, mehr Arbeitgeberattraktivität.",
        author: "Hans Arnet",
        role: "CEO",
        company: "Raiffeisenbank Luzerner Landschaft Nordwest",
      },
      {
        text: "Früher hatten wir auf eine Stellenanzeige kaum Reaktionen. Heute bekommen wir auf jede Ausschreibung 50 bis 60 Bewerbungen – und das betrifft alle Bereiche.",
        author: "Carsten Graf",
        role: "Vorstandsvorsitzender",
        company: "PSD Bank Braunschweig",
      },
    ],
  },
  dataTable: {
    title: "Banken im DACH-Raum",
    subtitle: "Übersicht aller Banken mit 4-Tage-Woche-Initiativen in Deutschland, Österreich und der Schweiz.",
    headers: { bank: "Bank", country: "Land", model: "Modell", hours: "Stunden", status: "Status", result: "Ergebnis" },
    statusLabels: { aktiv: "Aktiv", pilot: "Pilot", geplant: "Geplant" },
    items: [
      { name: "Atom Bank", country: "UK", model: "4-Tage bei vollem Gehalt", hours: "34h", status: "aktiv" as const, highlight: "68 % weniger Krankheitstage" },
      { name: "PSD Bank Braunschweig", country: "DE", model: "4-Tage-Woche oder\n4,5-Tage-Woche", hours: "32-36h", status: "aktiv" as const, highlight: "Alle Stellen besetzt" },
      { name: "Raiffeisenbank Luzerner Landschaft Nordwest", country: "CH", model: "4-Tage-Woche", hours: "38h", status: "aktiv" as const, highlight: "Niedrigere Fluktuation" },
      { name: "Raiffeisenbank Surselva", country: "CH", model: "4-Tage-Woche", hours: "38h", status: "aktiv" as const, highlight: "Höhere Attraktivität" },
      { name: "Raiffeisenbank Appenzeller Hinterland", country: "CH", model: "4-Tage-Woche oder\n4,5-Tage-Woche", hours: "38h", status: "aktiv" as const, highlight: "Erhielten Bewerbungen von Grossbank-Mitarbeitenden" },
      { name: "Sparkasse zu Lübeck", country: "DE", model: "WertSchätze-Modell", hours: "Flexibel", status: "aktiv" as const, highlight: "Wahlfreiheit für alle" },
      { name: "Volksbank Euskirchen", country: "DE", model: "4-Tage-Woche", hours: "35h", status: "aktiv" as const, highlight: "0% Fluktuation" },
      { name: "Volksbank Kaiserslautern", country: "DE", model: "4-Tage-Woche", hours: "36h", status: "pilot" as const, highlight: "Pilotprojekt läuft" },
      { name: "Eckernförder Bank", country: "DE", model: "4-Tage optional", hours: "32-40h", status: "aktiv" as const, highlight: "Flexibles Modell" },
      { name: "VR Bank Niebüll", country: "DE", model: "4-Tage-Woche", hours: "34h", status: "pilot" as const, highlight: "Hohe Mitarbeiterzufriedenheit" },
    ],
  },
  download: {
    title: "Whitepaper",
    titleSuffix: " herunterladen",
    subtitle: "Erhalten Sie das vollständige Whitepaper mit allen Case Studies, Statistiken und dem Implementierungsleitfaden für die 4-Tage-Woche im Bankenwesen.",
    bulletPoints: [
      "Detaillierte Case Studies aller Pionier-Banken",
      "Statistiken und Forschungsergebnisse",
      "3-Phasen-Implementierungsleitfaden",
      "ROI-Berechnungen und Business Case",
    ],
    formLabels: {
      name: "Name *",
      namePlaceholder: "Max Mustermann",
      email: "E-Mail-Adresse *",
      emailPlaceholder: "max@beispiel.de",
      company: "Unternehmen (optional)",
      companyPlaceholder: "Ihre Bank / Ihr Unternehmen",
      position: "Position (optional)",
      positionPlaceholder: "z.B. Vorstand, HR-Leitung",
      submit: "Kostenlos herunterladen",
      submitting: "Wird gesendet...",
      disclaimer: "Mit dem Download akzeptieren Sie unsere Datenschutzbestimmungen.",
    },
    success: {
      title: "Vielen Dank!",
      description: "Klicken Sie auf den Button, um das Whitepaper als PDF herunterzuladen:",
      downloadButton: "PDF herunterladen",
    },
    whitepaperLanguageNote: "",
    toast: {
      successTitle: "Vielen Dank!",
      successDescription: "Ihr Download wird gleich gestartet.",
      errorTitle: "Fehler",
      errorDescription: "Es gab ein Problem. Bitte versuchen Sie es erneut.",
    },
    validation: {
      nameMin: "Name muss mindestens 2 Zeichen haben",
      emailInvalid: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    },
  },
  event: {
    badge: "Live-Webinar",
    languageNote: "Auf Deutsch",
    title: "Mehr Produktivität im Banking durch kürzere Arbeitszeiten",
    lead: "Während Helaba-Chef Thomas Groß mehr Arbeit fordert und Deutsche-Bank-Chef Christian Sewing den Leistungswillen anmahnt, liefern andere Banken bereits – mit weniger Arbeitstagen.",
    date: "Di, 5. Mai 2026, 12:00 Uhr",
    context: "Fachkräftemangel und demografischer Wandel treffen Banken hart, gerade im ländlichen Raum. Flexible Arbeitsmodelle sind kein Nice-to-have mehr, sondern ein strategisches Instrument, um als Arbeitgeber relevant zu bleiben – und gleichzeitig Ergebnisse zu liefern.",
    contextProof: "Die PSD Bank Braunschweig hat ihr Kreditvolumen-Ziel auf 130 Mio. Euro angehoben – mit 4-Tage-Woche. Die Raiffeisenbank Appenzeller Hinterland hat das Modell als eine der ersten Banken in der Schweiz pilotiert – mit messbaren Effekten auf Mitarbeiterzufriedenheit und Arbeitgeberattraktivität.",
    speakersTitle: "Unsere Gäste",
    speakers: [
      { name: "Simon Frehner", role: "Vorsitzender der Bankleitung, Raiffeisenbank Appenzeller Hinterland" },
      { name: "Carsten Graf", role: "Vorstandssprecher, PSD Bank Braunschweig" },
    ],
    hostsLabel: "Moderation",
    hosts: [
      { name: "Carsten Meier", role: "4-Tage-Woche Deutschland Initiative", url: "https://www.4tagewoche.org" },
      { name: "Veit Hailperin", role: "4-Tage-Woche Schweiz & Österreich", url: "https://www.hailperin.ch" },
    ],
    agendaTitle: "Was Sie erwartet",
    agenda: [
      "Wie funktioniert die Einführung im Bankenwesen wirklich?",
      "Was bringt's für Recruiting und Mitarbeiterbindung – und was nicht?",
      "Welche flexiblen Modelle funktionieren, welche scheitern?",
      "Harte Fragen zu Produktivität, Krankenstand und Kundenerfahrung",
    ],
    audience: "Für Vorstände, Geschäftsführung und HR-Leitungen in Banken und Finanzinstituten.",
    duration: "60 Min.",
    format: "Online",
    price: "Kostenlose Teilnahme",
    signupButton: "Jetzt kostenlos anmelden",
    linkedinButton: "Auf LinkedIn ansehen",
  },
  contact: {
    fazitTitle: "Der richtige Zeitpunkt für mutige Schritte",
    fazitText: "Die 4-Tage-Woche ist keine Zukunftsvision mehr – sie ist gelebte Realität in zukunftsorientierten Banken. Ob als strategische Antwort auf den Fachkräftemangel, als Investition in die Mitarbeitergesundheit oder als Vorbereitung auf die KI-Transformation: Jetzt ist der richtige Zeitpunkt.",
    phasesTitle: "Ihr Weg zur 4-Tage-Woche",
    phases: [
      { number: "01", title: "Management-Workshop", description: "Analyse der Ausgangssituation und Entwicklung eines maßgeschneiderten Konzepts" },
      { number: "02", title: "Pilotierung", description: "Begleitete Einführung in ausgewählten Bereichen mit kontinuierlicher Evaluation" },
      { number: "03", title: "Rollout", description: "Schrittweise Ausweitung auf das gesamte Unternehmen mit Erfolgsmessung" },
    ],
    ctaTitle: "Bereit für den nächsten Schritt?",
    ctaText: "Vereinbaren Sie ein unverbindliches Kennenlerngespräch und erfahren Sie, wie die 4-Tage-Woche auch in Ihrer Bank funktionieren kann.",
    downloadButton: "Whitepaper herunterladen",
    contacts: [
      { name: "Carsten Meier", role: "4-Tage-Woche Deutschland" },
      { name: "Veit Hailperin", role: "4-Tage-Woche Schweiz & 4-Tage-Woche Österreich" },
    ],
    impressum: "Impressum",
    datenschutz: "Datenschutz",
    copyright: "© 2026 4tagewoche.org – Beratung für Arbeitszeitinnovation",
  },
  businessCase: {
    backToReport: "Zurück zum Report",
    badge: "Kostenloses Angebot",
    heroTitle: "Lohnt sich die 4-Tage-Woche für mein Unternehmen?",
    heroSubtitle: "Wir rechnen euren individuellen Banking Case durch – datenbasiert.",
    intro1: "Auf Basis unserer Erfahrung aus zahlreichen Beratungsprojekten und unserer Datengrundlage zu Banken im DACH-Raum erstellen wir einen individuellen Business Case für euer Institut.",
    intro2: "In einem 30-minütigen Call möchten wir euren Fall besser verstehen. Im Nachgang stellen wir euch einen massgeschneiderten Business Case zur Verfügung, mit dem ihr intern fundiert diskutieren könnt, ob eine 4-Tage-Woche für euch sinnstiftend ist.",
    benefits: [
      { title: "30-Minuten-Call", desc: "Wir verstehen eure Ausgangslage, eure Ziele und eure Bedenken." },
      { title: "Individueller Business Case", desc: "Konkrete Zahlen für euer Institut – Produktivität, Recruiting, Krankenstand." },
      { title: "Diskussionsgrundlage", desc: "Ein Dokument, mit dem ihr im Vorstand und mit dem Aufsichtsrat arbeiten könnt." },
    ],
    formTitle: "Business Case anfragen",
    formSubtitle: "Erzählt uns kurz von eurer Situation – wir melden uns innerhalb von zwei Werktagen.",
    fields: {
      name: "Name",
      namePlaceholder: "Vor- und Nachname",
      position: "Position",
      positionPlaceholder: "z. B. Vorstand, HR-Leitung",
      company: "Unternehmen",
      companyPlaceholder: "Name eures Instituts",
      situation: "Ausgangslage",
      situationPlaceholder: "Wie sieht eure aktuelle Personal- und Arbeitszeitsituation aus? Welche Herausforderungen treiben euch um?",
      perspective: "Eure aktuelle Perspektive auf die 4-Tage-Woche",
      perspectivePlaceholder: "Wie steht ihr heute zum Thema? Was sind offene Fragen, was sind Bedenken?",
      privacy: "Ich akzeptiere die Datenschutzbestimmungen und stimme zu, dass meine Angaben zur Bearbeitung der Anfrage gespeichert werden.",
      submit: "Business Case anfragen",
      submitting: "Wird gesendet …",
    },
    validation: {
      nameMin: "Bitte gib deinen Namen an.",
      positionMin: "Bitte gib deine Position an.",
      companyMin: "Bitte gib euer Unternehmen an.",
      situationMin: "Bitte beschreibe eure Ausgangslage in mindestens einem Satz.",
      perspectiveMin: "Bitte beschreibe eure Perspektive in mindestens einem Satz.",
      privacyRequired: "Bitte akzeptiere die Datenschutzbestimmungen.",
    },
    success: {
      title: "Vielen Dank für eure Anfrage!",
      description: "Wir melden uns innerhalb von zwei Werktagen, um einen 30-minütigen Call zu vereinbaren.",
      backButton: "Zurück zum Report",
    },
    toast: {
      successTitle: "Anfrage gesendet",
      successDescription: "Wir melden uns in Kürze bei euch.",
      errorTitle: "Etwas ist schiefgelaufen",
      errorDescription: "Bitte versucht es erneut oder schreibt uns direkt eine E-Mail.",
    },
  },
};
